export const DEFAULT_PAGE_IMAGES = {
  home: {
    hero: '/assets/home/JS68201971.avif',
    whyUs: '/assets/home/why-us.jpg',
    slide1: '/assets/home/slide-1.jpg',
    slide2: '/assets/home/slide-2.jpg',
    slide3:
      'https://images.unsplash.com/photo-1518091043644-c1d4457512c6?auto=format&fit=crop&w=1200&q=80',
    slide4: '/assets/home/slide-4.jpg',
    slides: [
      '/assets/home/slide-1.jpg',
      '/assets/home/slide-2.jpg',
      'https://images.unsplash.com/photo-1518091043644-c1d4457512c6?auto=format&fit=crop&w=1200&q=80',
      '/assets/home/slide-4.jpg',
    ],
  },
  about: {
    mission: '/assets/home/hero.jpg',
    whyChoose: '/assets/home/overview-action.jpg',
    manufacturing: '/assets/home/why-us.jpg',
  },
};

export function mergePageImages(data) {
  return {
    home: { ...DEFAULT_PAGE_IMAGES.home, ...(data?.home || {}) },
    about: { ...DEFAULT_PAGE_IMAGES.about, ...(data?.about || {}) },
  };
}
